<div class="modal-back">
    <div class="modal-front">
        <ng-content></ng-content>
    </div>
    <div class="modal-close" (click)="close()"></div>
</div>
